import type { SmartSortProduct } from '@iheartjane/dm-sdk';
import { hideStrikethroughPrice } from '@iheartjane/menu';
import { Button, Typography } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import type {
  AvailableWeights,
  ProductSearchResultViewModel,
} from '@jane/bloom/viewModels/productSearch';
import type { AlgoliaProduct } from '@jane/search/types';

import styles from './selectWeightForm.module.css';
import { weightLabel } from './weightLabel';

interface WeightButtonsProps {
  formattedWeight?: AvailableWeights;
  product: ProductSearchResultViewModel;
  selectedWeight: string;
  setSelectedWeight: (weight: string) => void;
  smartProductInstance?: SmartSortProduct<AlgoliaProduct>;
  weight: string;
}

export function WeightButtons({
  formattedWeight,
  product,
  selectedWeight,
  setSelectedWeight,
  smartProductInstance,
  weight,
}: WeightButtonsProps) {
  const { pinnedStore } = useRootLoaderData();
  const showStrikethrough =
    formattedWeight?.fullPriceFormatted !== formattedWeight?.priceFormatted &&
    !hideStrikethroughPrice(pinnedStore.state);

  return (
    <div className={styles['productCardFormWeightsButton']}>
      <Button
        label={
          <div className={styles['productCardFormWeightsButtonLabel']}>
            {formattedWeight?.priceFormatted && (
              <Typography
                variant="body-bold"
                data-testid="product-price"
                className={clsx({
                  [styles['productCardFormWeightDealsText']]:
                    product.special_id && showStrikethrough,
                })}
                color="inherit"
              >
                {formattedWeight?.priceFormatted}
              </Typography>
            )}
            {product.special_amount &&
              formattedWeight?.fullPriceFormatted &&
              showStrikethrough && (
                <Typography color="grays-mid" variant="body-bold" strikeThrough>
                  {formattedWeight?.fullPriceFormatted}
                </Typography>
              )}
          </div>
        }
        subLabel={weightLabel(weight)}
        size="jumbo"
        variant={
          selectedWeight === formattedWeight?.formattedWeight
            ? 'tertiary-selected'
            : 'tertiary'
        }
        full
        onClick={() => {
          setSelectedWeight(formattedWeight?.formattedWeight || '');
          if (smartProductInstance) {
            smartProductInstance.click();
          }
        }}
      />
    </div>
  );
}
